import loadable from '@loadable/component';

export const OrgDashboardViewJobRecommendedCandidatePageLoadable = loadable(
  () => import('./OrgDashboardViewJobRecommendedCandidatePage'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardViewJobRecommendedCandidatePage,
  },
);
